import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, Container, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { beadingGroupsImages } from '../../utils/BeadsData';

const BeadingGroups = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 10, mx: 'auto', mb: isMobile ? 2 : 8 }}>
                <Typography variant="h4" gutterBottom align="center" fontWeight="bold" sx={{ mt: isMobile ? 15 : 'auto' }}>Women's Beading Groups</Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 1 }}>
                    <Grid item xs={12} md={8}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            loop={true}
                            style={{ width: '100%', height: 'auto', borderRadius: '2rem' }}
                            sx={{
                                '.swiper-wrapper': {
                                    borderRadius: '2rem',
                                }
                            }}
                        >
                            {beadingGroupsImages.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 400 : 520 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '2rem' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                                fontSize: isMobile ? '0.75rem' : '1rem',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ mt: 4 }}>
                        <Typography variant="h6" paragraph fontWeight="bold">
                            THE DUPOTO WOMEN'S GROUP HAS BEEN SO SUCCESSFUL THAT IT IS NOW USED AS A MODEL FOR SIMILAR PROGRAMS ELSEWHERE IN THE COUNTRY.
                        </Typography>

                        <Box>
                            <img src="assets/img/beadings/Dupoto-Woman.png" alt="Dupoto-Woman"
                                style={{
                                    width: '100%', height: '100%', objectFit: 'cover', borderRadius: '2rem',
                                }}
                            />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
            <FooterOne />
        </Box>
    );
};

export default BeadingGroups;
